import { singleton } from 'tsyringe';
import { fmcApiBaseUrlEnv, HostEnv, hostEnv } from '../../constants/env-config.const';
import { EpJsConfig } from '../../models/config.model';
import { RemoteBrandConfig, RemoteBrandConfigResp } from '../../models/remote-brand-config.resp';
import { assignDefined } from '../../models/util.model';

@singleton()
export class ConfigUtilService{
  private config: EpJsConfig = new EpJsConfig();
  private remoteBrandConfig: RemoteBrandConfig = {};

  updateConfig(config: Partial<EpJsConfig>){
    if(config?.env){
      config.env = config.env.toUpperCase();

      config.host = config.host || hostEnv[config.env];
      config.fmcApiBaseUrl = config.fmcApiBaseUrl || fmcApiBaseUrlEnv[config.env];
    }
    this.config = {...this.config, ...config};
  }

  loadRemoteConfig(configResp: Partial<RemoteBrandConfigResp> = {}){
    let configUpdates: Partial<EpJsConfig> = {};
    const config = configResp.config || {};
    /**
     * Store remote brand config and merge with existing
     * */
    this.remoteBrandConfig = {...this.remoteBrandConfig, ...config};

    // Store and update apiHost (AdServer URL)
    switch(this.config.env){
      case HostEnv.Stage:
        if(config.qaAdServerUrl){
          configUpdates = assignDefined(configUpdates, {
            apiHost: config.qaAdServerUrl
          });
        }
        break;

      case HostEnv.Prod:
        if(config.prodAdServerUrl){
          configUpdates = assignDefined(configUpdates, {
            apiHost: config.prodAdServerUrl
          });
        }
        break;
    }

    this.updateConfig(configUpdates);
  }

  replaceConfig(config: Partial<EpJsConfig>){
    this.config = new EpJsConfig(config);
  }

  getConfig(){
    return {...this.config};
  }

  getBrandConfig(){
    return {...this.remoteBrandConfig};
  }
}
